// tslint:disable:object-literal-sort-keys
import React from "react";

import { useQuery } from "@apollo/client";

// import InputAdornment from "@material-ui/core/InputAdornment";
// import TextField from "@material-ui/core/TextField";

import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
// import SearchIcon from "@material-ui/icons/Search";

import TreeView from "@material-ui/lab/TreeView";
import TreeItem from "@material-ui/lab/TreeItem";

import * as _ from "lodash";

import collections from "./collections";

import CustomSelectSimple from "../../custom-select-simple";

// import FormattedNodeRow from "./components/formatted-node-row";

// see com.adcon.livedata.collections.common.PanelCollectionTemplateManager#categories
const TEMPLATE_COLLECTION_CATEGORIES = [
  "weather",
  "disease",
  "water",
  "irrigation",
  "others",
];

interface Props {
  name: string;
  label?: string;
  // nodes: any; // TODO is nodes not an array?
  showId?: boolean;
  value?: any;
  onChange: (event: React.ChangeEvent<any> | any) => void;
  // nodeClasses?: NodeClasses[];
}

// TODO Material Design
function PanelCollectionSelect(props: Props) {
  const {
    name,
    label,
    // nodes,
    // showId = false,
    value: oldValue,
    onChange,
    // nodeClasses = []
  } = props;
  // const classes = useStyles(props);

  // const [search, setSearch] = useState("");

  // tree selection
  const [selected, setSelected] = React.useState<string>(oldValue || "weather");
  const handleSelect = (event: React.ChangeEvent<{}>, nodeIds: string) => {
    // console.log("handleSelect", nodeIds, event);
    if (!nodeIds.startsWith("category_")) {
      setSelected(nodeIds);
      onChange(nodeIds); // TODO currentSelected
      // TODO handleClose?
    }
  };

  // useEffect(() => setSelected())

  // const [selection, setSelection] = useState(
  //   oldValue
  //     ? nodes.find(/* TODO nodes or data? */
  //         (x: any) => `${x.name}` === `${oldValue}`
  //       )
  //     : undefined
  // );
  // const [newSelection, setNewSelection] = useState(selection);

  const { data, error, loading } = useQuery(collections);
  if (loading) {
    return <div>Loading...</div>;
  }
  if (error) {
    console.error(error);
    return <p>Error :(</p>;
  }
  // console.log("data.collections", data);

  // const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   setSearch(event.target.value);
  // };

  const filteredNodes =
    /*data && data.collections && ((nodeClasses && nodeClasses.length > 0) || search.length > 0)
      ? filterNodes(data.collections, nodeClasses, search)
      :*/ data.collections;
  const filtered = filteredNodes; // && flattened([filteredNodes].map((node: any) => mapNode(node))[0]);

  // const innerNodeIds = data
  //   .filter((node: any) => node.children && node.children.length > 0)
  //   .map((node: any) => `${node.id}`);

  // function mapTree(tree: any) {
  //   return (
  //     <TreeItem nodeId={`${tree.name}`} label={tree.name}>
  //       {data.filter().map((node: any) => mapTree(node))}
  //     </TreeItem>
  //   );
  // }

  const currentSelected = data.collections.find(
    (c: any) => c.name === (selected || "weather")
  );
  // console.log("selected", selected, currentSelected);

  return (
    <CustomSelectSimple
      name={name}
      label={label}
      itemToString={(value) => (value ? `${value.name}` : "")}
      value={currentSelected}
      // onAccept={() => {
      //   // setSelection(newSelection);
      //   // onChange(newSelection);
      //   onChange(currentSelected);
      // }}
      // value={selection}
      // onAccept={() => {
      //   setSelection(newSelection);
      //   onChange(newSelection);
      // }}
    >
      {/* <TextField
        // label="Search"
        placeholder="Search…"
        value={search}
        onChange={handleSearchChange}
        fullWidth
        autoFocus
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
          "aria-label": "Search"
        }}
      /> */}
      {/* TODO on select => setNewSelection */}
      <TreeView
        // defaultExpanded={innerNodeIds}
        defaultExpanded={[`category_${currentSelected.category}`]}
        defaultCollapseIcon={<ExpandMoreIcon />}
        defaultExpandIcon={<ChevronRightIcon />}
        defaultEndIcon={<div style={{ width: 24 }} />}
        selected={selected}
        onNodeSelect={handleSelect}
        style={{ padding: "8px", maxHeight: "75vh" }} // TODO use theme.spacing
      >
        {/* {data && mapTree(data)} */}
        {data &&
          TEMPLATE_COLLECTION_CATEGORIES.map((category: string) => (
            <TreeItem
              key={`category_${category}`}
              nodeId={`category_${category}`}
              label={category}
            >
              {_.sortBy(
                filtered.filter((node: any) => node.category === category),
                "name"
              ).map((node: any) => (
                // TODO only show if nodes exist
                <TreeItem
                  key={`collection_template_${node.name}`}
                  nodeId={`${node.name}`}
                  label={node.name}
                ></TreeItem>
              ))}
            </TreeItem>
          ))}
      </TreeView>
    </CustomSelectSimple>
  );
}

export default PanelCollectionSelect;
